import { render, staticRenderFns } from "./pendingProfile.vue?vue&type=template&id=92902e68"
import script from "./pendingProfile.vue?vue&type=script&lang=js"
export * from "./pendingProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports